(function () {
    'use strict';

    angular
        .module('visualGuidelinesControllers', []);
})();
